const ItemIcon = ({ color }) => (
  <span
    style={{
      backgroundColor: color,
      display: 'inline-block',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      marginRight: '8px',
      verticalAlign: 'middle'
    }}
  />
)

export default ItemIcon
